import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { setSelectedSize } from '../../../containers/customizer.duck';

const SizeTab = ({ sizes, onChange }) => {
  const [activeTab, setActivetab] = useState(null);
  return (
    <div className="size-tab">
      <div className="size-tab_wrap">
        {sizes &&
          sizes.map((size, i) => (
            <div
              role="presentation"
              key={size.id}
              className={`size-tab_button ${activeTab === i &&
                'size-tab_button-selected'}`}
              onClick={() => {
                setActivetab(i);
                onChange(i);
              }}
            >
              {size.value}
            </div>
          ))}
      </div>
    </div>
  );
};

SizeTab.propTypes = {
  sizes: PropTypes.array,
  onChange: PropTypes.func
};

export default SizeTab;
